<mat-card fxLayoutAlign="center">
  <mat-card-content class="statistiques">
    <mat-tab-group class="statistiques">

      <mat-tab label="Les articles les plus vus">
        <ng-container *ngIf="plusVues">
          <table class="table-content">
            <tbody>
              <tr>
                <th class="first">Article</th>
                <th>Catégorie</th>
                <th class="last">Nombre de vues</th>
              </tr>
            </tbody>
            <tbody>
              <tr *ngFor="let pv of plusVues" [routerLink]="['/page/', pv.id]">
                <td class="first">{{pv.question}}</td>
                <td>{{pv.categorie_obj.label}}</td>
                <td class="last">{{pv.vues}}</td>
              </tr>
            </tbody>
          </table>
          <mat-list class="puces" fxLayoutAlign="center">
            <mat-list-item class="puce">
              <button mat-button color="primary" (click)="reloadArticles(plusVuesPrevUrl, 'prev', 'plusVues')">
                <mat-icon>keyboard_arrow_left</mat-icon>
              </button>
            </mat-list-item>
            <mat-list-item class="center">{{((plusVuesPage * limit)- limit)+1}} - {{((plusVuesPage * limit)-limit)+plusVues.length}} / {{plusVuesNbElements}}</mat-list-item>
            <mat-list-item class="puce">
              <button mat-button color="primary" (click)="reloadArticles(plusVuesNextUrl, 'next', 'plusVues')">
                <mat-icon>keyboard_arrow_right</mat-icon>
              </button>
            </mat-list-item>
          </mat-list>
        </ng-container>
      </mat-tab>

      <mat-tab label="Les plus commentés">
        <ng-container *ngIf="plusCommentes">
          <table class="table-content">
            <tbody>
            <tr>
              <th class="first">Article</th>
              <th>Catégorie</th>
              <th class="last">Nombre de commentaires</th>
            </tr>
            </tbody>
            <tbody>
            <tr *ngFor="let pc of plusCommentes" [routerLink]="['/page/', pc.id]">
              <td class="first">{{pc.question}}</td>
              <td>{{pc.categorie_obj.label}}</td>
              <td class="last">{{pc.commentaires}}</td>
            </tr>
            </tbody>
          </table>
          <mat-list class="puces" fxLayoutAlign="center">
            <mat-list-item class="puce">
              <button mat-button color="primary" (click)="reloadArticles(plusCommentesPrevUrl, 'prev', 'plusCommentes')">
                <mat-icon>keyboard_arrow_left</mat-icon>
              </button>
            </mat-list-item>
            <mat-list-item class="center">{{((plusCommentesPage * limit)- limit)+1}} - {{((plusCommentesPage * limit)-limit)+plusCommentes.length}} / {{plusCommentesNbElements}}</mat-list-item>
            <mat-list-item class="puce">
              <button mat-button color="primary" (click)="reloadArticles(plusCommentesNextUrl, 'next', 'plusCommentes')">
                <mat-icon>keyboard_arrow_right</mat-icon>
              </button>
            </mat-list-item>
          </mat-list>
        </ng-container>
      </mat-tab>

      <mat-tab label="Les mieux notés">
        <ng-container *ngIf="mieuxNotes">
          <table class="table-content">
            <tbody>
            <tr>
              <th class="first">Article</th>
              <th>Catégorie</th>
              <th class="last">Note</th>
            </tr>
            </tbody>
            <tbody>
            <tr *ngFor="let mn of mieuxNotes" [routerLink]="['/page/', mn.id]">
              <td class="first">{{mn.question}}</td>
              <td>{{mn.categorie_obj.label}}</td>
              <td class="last">{{mn.note_moyenne}}</td>
            </tr>
            </tbody>
          </table>
          <mat-list class="puces" fxLayoutAlign="center">
            <mat-list-item class="puce">
              <button mat-button color="primary" (click)="reloadArticles(mieuxNotesPrevUrl, 'prev', 'mieuxNotes')">
                <mat-icon>keyboard_arrow_left</mat-icon>
              </button>
            </mat-list-item>
            <mat-list-item class="center">{{((mieuxNotesPage * limit)- limit)+1}} - {{((mieuxNotesPage * limit)-limit)+mieuxNotes.length}} / {{mieuxNotesNbElements}}</mat-list-item>
            <mat-list-item class="puce">
              <button mat-button color="primary" (click)="reloadArticles(mieuxNotesNextUrl, 'next', 'mieuxNotes')">
                <mat-icon>keyboard_arrow_right</mat-icon>
              </button>
            </mat-list-item>
          </mat-list>
        </ng-container>
      </mat-tab>

      <mat-tab label="Articles par catégorie">
        <ng-container *ngIf="categories">
          <table class="table-content">
            <tbody>
            <tr>
              <th class="first">Catégorie</th>
              <th>Nombre d'articles</th>
              <th class="last">Nb articles online</th>
            </tr>
            </tbody>
            <tbody>
            <tr *ngFor="let cat of categories" [routerLink]="['/faq/', cat.id]">
              <td class="first">{{cat.label}}</td>
              <td>{{cat.nb_articles}}</td>
              <td class="last">{{cat.nb_articles_online}}</td>
            </tr>
            </tbody>
          </table>
          <mat-list class="puces" fxLayoutAlign="center">
            <mat-list-item class="puce">
              <button mat-button color="primary" (click)="reloadCategories(prevUrl, 'prev')">
                <mat-icon>keyboard_arrow_left</mat-icon>
              </button>
            </mat-list-item>
            <mat-list-item class="center">{{((page * limit)- limit)+1}} - {{((page * limit)-limit)+categories.length}} / {{nbElements}}</mat-list-item>
            <mat-list-item class="puce">
              <button mat-button color="primary" (click)="reloadCategories(nextUrl, 'next')">
                <mat-icon>keyboard_arrow_right</mat-icon>
              </button>
            </mat-list-item>
          </mat-list>
        </ng-container>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
</mat-card>
